import React, { useRef, memo } from 'react';
import FilterBar from './FilterBar';
import FilterBar2 from './FilterBar2';
import FilterView from './FilterView';
import Paper from '@material-ui/core/Paper';
import FilterSimples from './FilterSimples';


const LeftFilter = ({ filterTerms, setFilterTerms, filterData, setCnt }) => {
    
    const divRef = useRef(null);
    return (
        <div style={{ position: "relative" }}>
            {/*<div style={{ height: "100%", overflowY: "auto", overflowX: "clip" }}>*/}
            {/*    <div style={{ width: "calc(100% - 18px)", marginRight: "18px", overflowX: "clip" }}>*/}
            {/*        <FilterSimples filterData={filterData} setFilter={setFilterTerms} label="price" setCnt={setCnt} />*/}
            {/*        <FilterSimples filterData={filterData} setFilter={setFilterTerms} label="bedrooms" setCnt={setCnt} />*/}
            {/*        <FilterSimples filterData={filterData} setFilter={setFilterTerms} label="bathrooms" setCnt={setCnt} />*/}
            {/*        <FilterSimples filterData={filterData} setFilter={setFilterTerms} label="SqFtParsed" setCnt={setCnt} />*/}
            {/*        <FilterBar2 filterData={filterData} setFilter={setFilterTerms} />*/}
            {/*        <div style={{ bottom: "0px", height: divRef.current ? divRef.current.getBoundingClientRect().height : "auto", width: "100%", padding: "2px" }} />*/}
            {/*    </div>*/}
            {/*</div>*/}
            {/*<Paper ref={divRef} style={{ position: "absolute", bottom: "0px", height: "auto", width: "calc(100% - 18px)", padding: "2px", boxShadow: "none" }} >*/}
            {/*    <FilterView filterTerms={filterTerms} setFilterTerms={setFilterTerms} />*/}
            {/*</Paper>*/}
        </div>
    );
}

export default memo(LeftFilter);